import script from "./Repair05Skylight.vue?vue&type=script&setup=true&lang=js"
export * from "./Repair05Skylight.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__